import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import closeIcon from "../../../assets/icons/closeIcon.svg";
import { LeadCaptureFilterOptionsProps } from "./lead-capture-filter.props";
import "./lead-capture-filter.scss";
import dayjs, { Dayjs } from "dayjs";
import { isOnlyCountryCode } from "../../../utils/utils";
import CreatedByFilter from "./created-by-filter";
import LastSubmissionFilter from "./last-submission-filter";
import CreatedOnFilter from "./created-on-filter";
import FormNameFilter from "./form-name-filter";

const LeadCaptureFilterOptions: React.FC<LeadCaptureFilterOptionsProps> = (props: any) => {
  const {
    setSelectedLeadsFilters,
    setIsOpenFilter,
    isOpenFilter,
    selectedLeadsFilterOptions,
    setSelectedLeadsFilterOptions,
    onApplyFilters,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    activeFilters
  } = props;

  const [formName, setFormName] = useState("");
  const [formNameError, setFormNameError] = useState("");
  const [createdOn, setCreatedOn] = useState<string>("");
  const [createdOnError, setCreatedOnError] = useState("");
  const [createdOnStart, setCreatedOnStart] = useState<Dayjs | null>(null);
  const [createdOnEnd, setCreatedOnEnd] = useState<Dayjs | null>(null);
  const [createdOnStartError, setCreatedOnStartError] = useState("");
  const [createdOnEndError, setCreatedOnEndError] = useState("");
  const [createdByUserIds, setCreatedByUserIds] = useState<number[]>([]);
  const [createdByUserIdsError, setCreatedByUserIdsError] = useState("");
  const [lastSubmission, setLastSubmission] = useState<string>("");
  const [lastSubmissionError, setLastSubmissionError] = useState("");
  const [lastSubmissionStart, setLastSubmissionStart] = useState<Dayjs | null>(null);
  const [lastSubmissionEnd, setLastSubmissionEnd] = useState<Dayjs | null>(null);
  const [lastSubmissionStartError, setLastSubmissionStartError] = useState("");
  const [lastSubmissionEndError, setLastSubmissionEndError] = useState("");
  const [draftSelectedLeadsFilterOptions, setDraftSelectedLeadsFilterOptions] =
    useState<any[]>([]);

  useEffect(() => {
    if (isOpenFilter) {
      const updatedDraft = selectedLeadsFilterOptions.map((option: any) => {
        switch (option.label) {
          case "Form Name":
            return {
              ...option,
              value: !!activeFilters?.formName,
            };
          case "Created On":
            return {
              ...option,
              value: !!(activeFilters?.createdOnStart && activeFilters?.createdOnEnd),
            };
          case "Last Submission":
            return {
              ...option,
              value: !!(activeFilters?.lastSubmissionStart && activeFilters?.lastSubmissionEnd),
            };
          case "Created By":
            return {
              ...option,
              value: !!(activeFilters?.createdByUserIds?.length),
            };
          default:
            return option;
        }
      });

      setDraftSelectedLeadsFilterOptions(updatedDraft);

      if (activeFilters?.formName) {
        setFormName(activeFilters.formName);
      }

      if (activeFilters?.createdOnStart && activeFilters?.createdOnEnd) {
        const start = dayjs(activeFilters.createdOnStart);
        const end = dayjs(activeFilters.createdOnEnd);

        const match = (a: dayjs.Dayjs, b: dayjs.Dayjs) => a.isSame(b, "second");

        if (
          match(start, dayjs().startOf("day")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setCreatedOn("Today");
        } else if (
          match(start, dayjs().subtract(1, "day").startOf("day")) &&
          match(end, dayjs().subtract(1, "day").endOf("day"))
        ) {
          setCreatedOn("Yesterday");
        } else if (
          match(start, dayjs().startOf("week")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setCreatedOn("This Week");
        } else if (
          match(start, dayjs().startOf("month")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setCreatedOn("This Month");
        } else if (
          match(start, dayjs().subtract(1, "week").startOf("week").hour(0).minute(0).second(0)) &&
          match(end, dayjs().subtract(1, "week").endOf("week").hour(23).minute(59).second(0))
        ) {
          setCreatedOn("Last Week");
        } else if (
          match(start, dayjs().subtract(1, "month").startOf("month").hour(0).minute(0).second(0)) &&
          match(end, dayjs().subtract(1, "month").endOf("month").hour(23).minute(59).second(0))
        ) {
          setCreatedOn("Last Month");
        }
        else {
          setCreatedOn("Custom");
          setCreatedOnStart(start);
          setCreatedOnEnd(end);
        }

      }
      if (activeFilters?.lastSubmissionStart && activeFilters?.lastSubmissionEnd) {
        const start = dayjs(activeFilters.lastSubmissionStart);
        const end = dayjs(activeFilters.lastSubmissionEnd);

        const match = (a: dayjs.Dayjs, b: dayjs.Dayjs) => a.isSame(b, "second");

        if (
          match(start, dayjs().startOf("day")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setLastSubmission("Today");
        } else if (
          match(start, dayjs().subtract(1, "day").startOf("day")) &&
          match(end, dayjs().subtract(1, "day").endOf("day"))
        ) {
          setLastSubmission("Yesterday");
        } else if (
          match(start, dayjs().startOf("week")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setLastSubmission("This Week");
        } else if (
          match(start, dayjs().startOf("month")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setLastSubmission("This Month");
        } else if (
          match(start, dayjs().subtract(1, "week").startOf("week").hour(0).minute(0).second(0)) &&
          match(end, dayjs().subtract(1, "week").endOf("week").hour(23).minute(59).second(0))
        ) {
          setLastSubmission("Last Week");
        } else if (
          match(start, dayjs().subtract(1, "month").startOf("month").hour(0).minute(0).second(0)) &&
          match(end, dayjs().subtract(1, "month").endOf("month").hour(23).minute(59).second(0))
        ) {
          setLastSubmission("Last Month");
        }
        else {
          setLastSubmission("Custom");
          setLastSubmissionStart(start);
          setLastSubmissionEnd(end);
        }

      }

      if (activeFilters?.createdByUserIds?.length) {
        setCreatedByUserIds(activeFilters.createdByUserIds);
      }
    }
  }, [isOpenFilter]);
  const isAnyFilterSelected =draftSelectedLeadsFilterOptions.some(
    (option: any) => option.value
  );

  const handleChange = (e: any) => {
    // const tempSelectedLeadsFilterOptions = selectedLeadsFilterOptions?.map(
    //   (data: any) => {
    //     return data?.labels === e.target.id
    //       ? { ...data, value: !data?.value }
    //       : data;
    //   },
    // );
    const updatedDraft = draftSelectedLeadsFilterOptions.map((data: any) =>
      data?.labels === e.target.id ? { ...data, value: !data?.value } : data
    );
    const isFormNameUnchecked = e.target.id === "Form Name" && !e.target.checked;
    if (isFormNameUnchecked) {
      setFormName("");
      setFormNameError("");
    }

    const isCreatedByUnchecked = e.target.id === "Created By" && !e.target.checked;
    if (isCreatedByUnchecked) {
      setCreatedByUserIds([]);
      setCreatedByUserIdsError("");
    }
    const isCreatedOnUnchecked = e.target.id === "Created On" && !e.target.checked;
    if (isCreatedOnUnchecked) {
      setCreatedOn("");
      setCreatedOnStart(null);
      setCreatedOnEnd(null);
      setCreatedOnError("");
      setCreatedOnStartError("");
      setCreatedOnEndError("");
    }
    const isLastSubmissionUnchecked = e.target.id === "Last Submission" && !e.target.checked;
    if (isLastSubmissionUnchecked) {
      setLastSubmission("")
      setLastSubmissionStart(null);
      setLastSubmissionEnd(null);
      setLastSubmissionError("");
      setLastSubmissionStartError("");
      setLastSubmissionEndError("");
    }
    setDraftSelectedLeadsFilterOptions(updatedDraft);
    // setSelectedLeadsFilters(
    //   tempSelectedLeadsFilterOptions?.filter((data: any) => {
    //     return data?.value;
    //   }),
    // );
  };
  const handleReset = () => {
    const resetFilters = selectedLeadsFilterOptions.map((option: any) => ({
      ...option,
      value: false,
    }));

    setSelectedLeadsFilterOptions(resetFilters);
    setDraftSelectedLeadsFilterOptions(resetFilters);

    setFormName("");
    setFormNameError("");
    setLastSubmission("");
    setLastSubmissionError("");
    setLastSubmissionStart(null);
    setLastSubmissionEnd(null);
    setLastSubmissionStartError("");
    setLastSubmissionEndError("");
    setCreatedOnStart(null);
    setCreatedOnEnd(null);
    setCreatedOnStartError("");
    setCreatedOnEndError("");
    setCreatedOn("");
    setCreatedOnError("");
    setCreatedByUserIds([])
    setCreatedByUserIdsError("");
    setSelectedLeadsFilters([]);

    props.onApplyFilters({});
    setIsOpenFilter(false);
  };

  const handleFormNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFormName(value);
    if (value.trim() !== "") {
      setFormNameError("");
    }
  };


  const handleCreatedOnChange = (value: string) => {
    setCreatedOn(value);

    if (value.length > 0) {
      setCreatedOnError("");
    }
    if (value === "Custom") {
      setCreatedOnStart(null);
      setCreatedOnEnd(null);
      setCreatedOnStartError("");
      setCreatedOnEndError("");
    }
  };

  const handleLastSubmissionChange = (value: string) => {
    setLastSubmission(value);
    if (value.length > 0) {
      setLastSubmissionError("");
    }
    if (value === "Custom") {
      setLastSubmissionStart(null);
      setLastSubmissionEnd(null);
      setLastSubmissionStartError("");
      setLastSubmissionEndError("")
    }
  };
  const handleCreatedByChange = (selectedIds: number[]) => {
    setCreatedByUserIds(selectedIds);

    if (selectedIds.length > 0) {
      setCreatedByUserIdsError("");
    }
  };

  const handleCreatedOnDateRange = (from: Date | null, to: Date | null) => {
    setCreatedOnStart(from ? dayjs(from) : null);
    setCreatedOnEnd(to ? dayjs(to) : null);

    if (from) setCreatedOnStartError("");
    if (to) setCreatedOnEndError("");
  };


  const handleLastSubmissionDateRange = (from: Date | null, to: Date | null) => {
    setLastSubmissionStart(from ? dayjs(from) : null);
    setLastSubmissionEnd(to ? dayjs(to) : null);

    if (from) setLastSubmissionStartError("");
    if (to) setLastSubmissionEndError("");
  };

  const isFormNameEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Form Name"
  )?.value;
  const isCreatedOnEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Created On"
  )?.value;
  const isLastSubmissionEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Last Submission"
  )?.value;
  const isCreatedByEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Created By"
  )?.value;
  const renderFilterField = (optionLabel: string) => {
    switch (optionLabel) {
      case "Form Name":
        return (
          <FormNameFilter
            formName={formName}
            handleFormNameChange={handleFormNameChange}
            isFormNameEnabled={isFormNameEnabled}
            formNameError={formNameError}
          />
        );
      case "Created On":
        return (
          <CreatedOnFilter
            value={createdOn}
            onChange={handleCreatedOnChange}
            isCreatedOnEnabled={isCreatedOnEnabled}
            onDateRangeChange={handleCreatedOnDateRange}
            createdOnError={createdOnError}
            createdOnStartError={createdOnStartError}
            createdOnEndError={createdOnEndError}
            setCreatedOnFromDate={setCreatedOnStart}
            setCreatedOnToDate={setCreatedOnEnd}
            fromDate={createdOnStart}
            toDate={createdOnEnd}
          />
        );
      case "Last Submission":
        return (
          <LastSubmissionFilter
            value={lastSubmission}
            onChange={handleLastSubmissionChange}
            isLastSubmissionEnabled={isLastSubmissionEnabled}
            onDateRangeChange={handleLastSubmissionDateRange}
            lastSubmissionError={lastSubmissionError}
            lastSubmissionStartError={lastSubmissionStartError}
            lastSubmissionEndError={lastSubmissionEndError}
            setLastSubmissionFromDate={setLastSubmissionStart}
            setLastSubmissionToDate={setLastSubmissionEnd}
            fromDate={createdOnStart}
            toDate={createdOnEnd}
          />
        );
      case "Created By":
        return (
          <CreatedByFilter
            value={createdByUserIds}
            onChange={handleCreatedByChange}
            isCreatedByEnabled={isCreatedByEnabled}
            createdByUserIdsError={createdByUserIdsError}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        );
      default:
        return null;
    }
  };
  const handleApplyFilters = () => {
    let hasError = false;
    if (isFormNameEnabled && !formName.trim()) {
      setFormNameError("Enter Form Name");
      hasError = true;
    } else {
      setFormNameError("");
    }
    if (isCreatedByEnabled && createdByUserIds.length === 0) {
      setCreatedByUserIdsError("Select Created By");
      hasError = true;
    } else {
      setCreatedByUserIdsError("");
    }
    if (isCreatedOnEnabled) {
      if (createdOn.length === 0) {
        setCreatedOnError("Select Created On");
        hasError = true;
      } else {
        setCreatedOnError("");
      }
      if (createdOn.includes("Custom")) {
        if (!createdOnStart) {
          setCreatedOnStartError("Start date is required");
          hasError = true;
        } else if (!dayjs(createdOnStart).isValid() ||
          dayjs(createdOnStart).year() < 1900) {
          setCreatedOnStartError("Invalid date");
          hasError = true;
        } else {
          setCreatedOnStartError("");
        }

        if (!createdOnEnd) {
          setCreatedOnEndError("End date is required");
          hasError = true;
        } else if (!dayjs(createdOnEnd).isValid() ||
          dayjs(createdOnEnd).year() < 1900) {
          setCreatedOnEndError("Invalid date");
          hasError = true;
        } else {
          setCreatedOnEndError("");
        }
        if (
          createdOnStart &&
          createdOnEnd &&
          dayjs(createdOnStart).isValid() &&
          dayjs(createdOnEnd).isValid() &&
          dayjs(createdOnStart).isAfter(dayjs(createdOnEnd))
        ) {
          setCreatedOnStartError("Start date cannot be greater than end date");
          setCreatedOnEndError("End date cannot be less than start date");
          hasError = true;
        }
      } else {
        setCreatedOnStartError("");
        setCreatedOnEndError("");
      }
    }

    if (isLastSubmissionEnabled) {
      if (lastSubmission.length === 0) {
        setLastSubmissionError("Select Last Submission");
        hasError = true;
      } else {
        setLastSubmissionError("");
      }

      if (lastSubmission.includes("Custom")) {
        if (!lastSubmissionStart) {
          setLastSubmissionStartError("Start date is required");
          hasError = true;
        } else if (!dayjs(lastSubmissionStart).isValid() ||
          dayjs(lastSubmissionStart).year() < 1900) {
          setLastSubmissionStartError("Invalid date");
          hasError = true;
        } else {
          setLastSubmissionStartError("");
        }

        if (!lastSubmissionEnd) {
          setLastSubmissionEndError("End date is required");
          hasError = true;
        } else if (!dayjs(lastSubmissionEnd).isValid() ||
          dayjs(lastSubmissionEnd).year() < 1900) {
          setLastSubmissionEndError("Invalid date")
          hasError = true;
        } else {
          setLastSubmissionEndError("");
        }
        if (
          lastSubmissionStart &&
          lastSubmissionEnd &&
          dayjs(lastSubmissionStart).isValid() &&
          dayjs(lastSubmissionEnd).isValid() &&
          dayjs(lastSubmissionStart).isAfter(dayjs(lastSubmissionEnd))
        ) {
          setLastSubmissionStartError("Start date cannot be greater than end date");
          setLastSubmissionEndError("End date cannot be lesser than start date");
          hasError = true;
        }
      } else {
        setLastSubmissionStartError("");
        setLastSubmissionEndError("");
      }
    }
    if (hasError) {
      return;
    }
    const filtersToApply: any = {};
    if (isFormNameEnabled && formName.trim()) filtersToApply.formName = formName;
    if (isCreatedOnEnabled && createdOnStart && createdOnEnd) {
      filtersToApply.createdOnStart = createdOnStart;
      filtersToApply.createdOnEnd = createdOnEnd;
    }
    if (isLastSubmissionEnabled && lastSubmissionStart && lastSubmissionEnd) {
      filtersToApply.lastSubmissionStart = lastSubmissionStart;
      filtersToApply.lastSubmissionEnd = lastSubmissionEnd;
    }
    if (isCreatedByEnabled && createdByUserIds.length > 0) {
      filtersToApply.createdByUserIds = createdByUserIds;
    }
    onApplyFilters(filtersToApply);
    setSelectedLeadsFilterOptions(draftSelectedLeadsFilterOptions);
    setSelectedLeadsFilters(
      draftSelectedLeadsFilterOptions.filter((data: any) => data.value)
    );
    setIsOpenFilter(false);
  };
  return (
    <div className="lead-filter-options-wrapper">
      <div className="lead-filter-options-container">
        <div className="header-wrapper">
          <div className="lead-filter-options-container-header">
            <div className="lead-filter-options-container-header-text">
              Filters
            </div>
            <div className="lead-filter-options-container-header-icon">
              <img
                src={closeIcon}
                alt="Filter Icon"
                onClick={() => setIsOpenFilter(!isOpenFilter)}
              />
            </div>
          </div>
          <div className="lead-filter-options-container-subtext">
            Filter By Fields
          </div>
        </div>
        <div className="lead-filter-options-container-list">
          {draftSelectedLeadsFilterOptions.map((option: any) => (
            <div>
              <label htmlFor={option?.labels} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <Checkbox
                  checked={option?.value}
                  onChange={handleChange}
                  id={option?.labels}
                />
                <ListItemText primary={option?.labels} />
              </label>

              {option?.value && renderFilterField(option?.labels)}
            </div>
          ))}
          {isAnyFilterSelected && (
            <div className="lead-capture-filter-buttons">
              <button className="cancel-button" onClick={() => {
                handleReset();
              }}
              >
                Reset
              </button>
              <button className="next-button-wrapper" type="submit" onClick={handleApplyFilters}>
                Apply
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LeadCaptureFilterOptions;